import { PageRouteBuilder } from "@common/route/page-route-builder";
import { DeleteOrphanPeopleComponent } from "./delete-orphan-people-page.component";

export const deleteOrphanPeoplePageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-delete-orphan-people-page", DeleteOrphanPeopleComponent)
    .requiresLogin()
    .atUrl("/tools/delete-orphan-people")
    .withTitle("Delete Orphan People")
    .build();
